import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import './carousel.css';
import './styles.css';

const CarouselTemplate = ({autoplay, deck}) => (
  <div className='container'>
    <Slider className='slider-wrapper' autoplay={autoplay*1000}>
      {deck.map((slide, index) => {
        return (
          <div key={index}
            className='slider-content'
            style={{ 
            backgroundImage: `url('${slide.image}')`,
           }}>
            <div className='inner'>
              <h1>{slide.title}</h1>
              <p>{slide.text}</p>
            </div>
          </div>
        );
      })}
    </Slider> 
  </div>
);

CarouselTemplate.propTypes = {
  autoplay: PropTypes.number,
  deck: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string
    })
  )
};

const Carousel = ({slideDeck}) => (
  <div>
    <CarouselTemplate autoplay={slideDeck.autoplay} deck={slideDeck.deck} />
  </div>
);


Carousel.propTypes = {
  slideDeck: PropTypes.object
}

export default Carousel;

export const SlidesQuery = graphql`
fragment CarouselSlides on SlideDecksJson {
  deckName
  autoplay
  deck {
    image
    title
    text
  }
}
`


// WEBPACK FOOTER //
// ./src/components/Carousel/index.js